//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vModal from '@/core/vModal'
import { mapGetters } from 'vuex'
export default {
  name: 'ProductInfoModal',
  extends: vModal,
  data () {
    return {
      fields: [
        { id: 'BARCODE', label: '產品編號' },
        { id: 'PC_NAME', label: '品名規格' },
        { id: 'CO_PRICE', label: '現在售價' },
        { id: 'S_PRICE', label: '特賣價' },
        { id: 'S_DATE', label: '特賣期間' },
        { id: 'MEMO2', label: '商品說明' },
        { id: 'MULTI_FIELD1', label: '銷售技巧' }
      ],
      itemData: {}
    }
  },
  computed: {
    ...mapGetters([
      'theme'
    ])
  },
  created () {
    this.initData()
  },
  mounted () {
  },
  methods: {
    initData () {
      this.itemData = {
        BARCODE: '1',
        PC_NAME: '2',
        CO_PRICE: '3',
        S_PRICE: '4',
        S_DATE: '5',
        MEMO2: '6',
        MULTI_FIELD1: '7'
      }
    },
    dataReady () {
      this.itemData = this.modalData
    }
  }
}
